const camelCaseToLispCase = (text) => text.replace(/([A-Z])/g, $1 => `-${$1.toLowerCase()}`);

const getItems = () => {
  const items = document.querySelectorAll('[klickbox-internal-style]');
  return Array.from(items);
};

const jsonToCSS = (style) => {
  const keys = Object.keys(style);

  return keys.map(key => `${camelCaseToLispCase(key)}: ${style[key]} !important;`).join('');
};

export const getHtmlTag = (styles) => {
  const items = getItems();

  if (!items.length) {
    return '';
  }

  let tagStyle = '<style>';

  items.forEach((item) => {
    const itemEdit = item.getAttribute('klickbox-edit-item');
    const itemClass = item.getAttribute('klickbox-internal-style');

    const rules = styles[itemEdit].rules;

    tagStyle = `${tagStyle}.${itemClass} { ${jsonToCSS(rules)} }`;
  });

  tagStyle = `${tagStyle}</style>`;

  return tagStyle;
};

export const getElement = (item) => {
  const selector = `[klickbox-edit-item="${item}"][klickbox-internal-style]`;
  return document.querySelector(selector);
};



/** WEBPACK FOOTER **
 ** ./src/helpers/internalstyle/index.js
 **/